<div class="container">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="printerTypesFormGroup" (ngSubmit)="onPrinterTypeFormSubmit()">
                    <div class="card-header">
                        Printer Type
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">printer type name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['name'] }"
                                    formControlName="name" />
                                <div *ngIf="validationErrorsArray['name']" class="invalid-feedback">
                                    {{validationErrorsArray['name']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">lan *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['lan'] }" formControlName="lan">
                                    <option *ngFor="let presence of trueFalseArray" [value]="presence.value">
                                        {{presence.value}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['lan']" class="invalid-feedback">
                                    {{validationErrorsArray['lan']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">bluetooth *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['bluetooth'] }"
                                    formControlName="bluetooth">
                                    <option *ngFor="let presence of trueFalseArray" [value]="presence.value">
                                        {{presence.value}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['bluetooth']" class="invalid-feedback">
                                    {{validationErrorsArray['bluetooth']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">wifi *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['wifi'] }" formControlName="wifi">
                                    <option *ngFor="let presence of trueFalseArray" [value]="presence.value">
                                        {{presence.value}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['wifi']" class="invalid-feedback">
                                    {{validationErrorsArray['wifi']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">usb *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['usb'] }" formControlName="usb">
                                    <option *ngFor="let presence of trueFalseArray" [value]="presence.value">
                                        {{presence.value}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['usb']" class="invalid-feedback">
                                    {{validationErrorsArray['usb']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">status *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm" formControlName=status>
                                    <option *ngFor="let status of printerTypeStatusArray" [value]=status.value>
                                        {{status.label}}</option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">printer manufacturer *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['printerManufacturers'] }"
                                    formControlName="printerManufacturers">
                                    <option *ngFor="let printerManufacturer of printerManufacturers"
                                        [value]=printerManufacturer.id>
                                        {{printerManufacturer.name}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['printerManufacturers']" class="invalid-feedback">
                                    {{validationErrorsArray['printerManufacturers']}}
                                </div>
                            </dd>
                        </dl>
                    </div>
                    <div class="card-footer">
                        <a class="btn btn-default btn-sm" href="/hardware/printers">
                            <i class="fa fa-times"></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right" type="submit">
                            <i class="fa fa-save"></i> <br />
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>